//
export default [
    {
        text: "#",
        value: "id",
        width: "5%"
    },
    {
        text: "nombre",
        value: "name",
    },
    {
        text: "ciclico",
        value: "is_cyclic",
        align: "center",
        format: "boolean",
    },
    {
        text: "creacion",
        value: "created_at",
        align: "right",
        format: "datetime",
    },
]